<!-- TODO: Remove all fnd classes - this should only use emds classes-->
<div class="find-control-advanced">
  <div class="body-static">
    <div class="left-group">
      <button
        [id]="baseId + '-findcontrol-new'"
        class="btn btn-light btn-flush-left"
        *ngIf="this.findControlDto?.SystemPermission.IsNewAllowed && !this.isNewButtonHidden"
        (click)="onNewClick()"
        translate
      >
        + New
      </button>
      <div class="filters-info">
        <p class="filters-info-title">
          <ng-container *ngIf="!loadingData"> Showing {{ removeFiltersOption ? displayFilterOption : displayRowCount }} </ng-container>
          <ng-container *ngIf="removeFiltersOption">
            <span class="dash"> - </span>
            <a routerLink="#" (click)="removeFilters()"><b>Clear</b></a>
          </ng-container>
        </p>
      </div>
    </div>
    <div *ngIf="!loadingConfig && findControlDto" class="right-group">
      <div class="quick-search-row">
        <mat-form-field class="quick-search mat-flush quick-search-input" appearance="outline">
          <input apAutoFocus matInput #input [formControl]="formControl" placeholder="Quick Search" type="text" />
          <span matPrefix>
            <mat-icon (click)="onSearchClick()">search</mat-icon>
          </span>
        </mat-form-field>
        <a [id]="baseId + '-findcontrol-filters'" role="button" title="filters" *ngIf="!isFilterButtonHidden" (click)="onFiltersClick()">
          <mat-icon class="material-icons" [ngClass]="{'active-filters': !!userSearchParameters}">filter_list</mat-icon></a
        >
        <div class="seperator"></div>
        <a class="file" [id]="baseId + '-findcontrol-file'">
          <mat-icon [matMenuTriggerFor]="menu">settings_application</mat-icon>
          <mat-menu #menu="matMenu">
            <button
              [id]="baseId + '-findcontrol-export'"
              mat-menu-item
              [disabled]="!findControlDto?.FindControlBehavior?.AllowExport || !getSelectedItemIds().length"
              (click)="onExportClick()"
              translate
            >Export...</button>
            <button
              [id]="baseId + '-findcontrol-export-current'"
              mat-menu-item
              [disabled]="!findControlDto?.FindControlBehavior?.AllowExport || !dataList.length"
              (click)="onExportCurrentClick()"
              translate
            >Export Current...</button>
            <button
              [id]="baseId + '-findcontrol-export'"
              mat-menu-item
              [disabled]="!findControlDto?.FindControlBehavior?.AllowExport || findControlDto?.FindControlBehavior?.UseGenericOutputFormat"
              (click)="onExportAllClick()"
              translate
            >Export All...</button>
            <button
              [id]="baseId + '-findcontrol-import'"
              mat-menu-item
              [disabled]="!findControlDto?.FindControlBehavior?.AllowImport"
              (click)="onImportClick()"
              translate
            >Import...</button>
            <button
              [id]="baseId + '-findcontrol-columns'"
              mat-menu-item
              [disabled]="findControlDto?.IsDynamic || !findControlDto?.FindControlBehavior?.BusinessObjectRequired || !findControlDto?.FindControlBehavior?.DefaultColumnsConfig"
              (click)="onReorderColumnsClick()"
              translate
            >Reorder Columns...</button>
            <button
              [id]="baseId + '-findcontrol-modify'"
              mat-menu-item
              [disabled]="disableModifyFind"
              (click)="onModifyFindClick()"
              translate
            >Modify Find</button>
          </mat-menu>
        </a>
      </div>
      <div class="checkbox-group" [formGroup]="checkboxFormGroup">
        <mat-checkbox *ngFor="let checkbox of checkboxData" [formControl]="checkbox.formControl" (change)="onCheckboxChange(checkbox)">{{checkbox?.checkboxText}}</mat-checkbox>
      </div>
    </div>
  </div>
  <div class="body-results">
    <div class="text-center" *ngIf="loadingData || loadingConfig">
      <ap-spinner size="3"></ap-spinner>
    </div>
    <div *ngIf="!loadingData && !loadingConfig">
      <ap-configurable-table
        [baseId]="baseId + '-findcontrol-table'"
        [tableId]="'find-table'"
        [clientColumnInfoList]="clientColumnInfoList"
        [serverColumnItemList]="serverColumnItemList"
        [dataItemList]="dataList"
        [setStickyHeaders]="true">
      </ap-configurable-table>
    </div>
  </div>
</div>
